/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

// THIS FILE IS GENERATED BY BUILD TOOL
// DO NOT EDIT IT MANUAL
import { wrapIcon } from '../../wrapIcon';
import { SVGProps } from 'react';
const SvgAppGalleryBase = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4 5C4 4.44772 4.44772 4 5 4H6C6.55228 4 7 4.44772 7 5V6C7 6.55228 6.55228 7 6 7H5C4.44772 7 4 6.55228 4 6V5Z"
      fill="currentColor"
    />
    <path
      d="M10.5 5C10.5 4.44772 10.9477 4 11.5 4H12.5C13.0523 4 13.5 4.44772 13.5 5V6C13.5 6.55228 13.0523 7 12.5 7H11.5C10.9477 7 10.5 6.55228 10.5 6V5Z"
      fill="currentColor"
    />
    <path
      d="M17 5C17 4.44772 17.4477 4 18 4H19C19.5523 4 20 4.44772 20 5V6C20 6.55228 19.5523 7 19 7H18C17.4477 7 17 6.55228 17 6V5Z"
      fill="currentColor"
    />
    <path
      d="M4 11.5C4 10.9477 4.44772 10.5 5 10.5H6C6.55228 10.5 7 10.9477 7 11.5V12.5C7 13.0523 6.55228 13.5 6 13.5H5C4.44772 13.5 4 13.0523 4 12.5V11.5Z"
      fill="currentColor"
    />
    <path
      d="M10.5 11.5C10.5 10.9477 10.9477 10.5 11.5 10.5H12.5C13.0523 10.5 13.5 10.9477 13.5 11.5V12.5C13.5 13.0523 13.0523 13.5 12.5 13.5H11.5C10.9477 13.5 10.5 13.0523 10.5 12.5V11.5Z"
      fill="currentColor"
    />
    <path
      d="M17 11.5C17 10.9477 17.4477 10.5 18 10.5H19C19.5523 10.5 20 10.9477 20 11.5V12.5C20 13.0523 19.5523 13.5 19 13.5H18C17.4477 13.5 17 13.0523 17 12.5V11.5Z"
      fill="currentColor"
    />
    <path
      d="M4 18C4 17.4477 4.44772 17 5 17H6C6.55228 17 7 17.4477 7 18V19C7 19.5523 6.55228 20 6 20H5C4.44772 20 4 19.5523 4 19V18Z"
      fill="currentColor"
    />
    <path
      d="M10.5 18C10.5 17.4477 10.9477 17 11.5 17H12.5C13.0523 17 13.5 17.4477 13.5 18V19C13.5 19.5523 13.0523 20 12.5 20H11.5C10.9477 20 10.5 19.5523 10.5 19V18Z"
      fill="currentColor"
    />
    <path
      d="M17 18C17 17.4477 17.4477 17 18 17H19C19.5523 17 20 17.4477 20 18V19C20 19.5523 19.5523 20 19 20H18C17.4477 20 17 19.5523 17 19V18Z"
      fill="currentColor"
    />
  </svg>
);
const SvgAppGallery = wrapIcon(SvgAppGalleryBase);
export default SvgAppGallery;
